module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "list-title"
  }, [_vm._v("基 础")]), _vm._v(" "), _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "path": "/mobile/demo/btn",
      "name": "按 钮"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/form-group",
      "name": "表 单"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/phone-code",
      "name": "验证码"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/drawer",
      "name": "动效抽屉"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/touch",
      "name": "手势操作"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/slider",
      "name": "内容滚动"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list-title"
  }, [_vm._v("输 入")]), _vm._v(" "), _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "path": "/mobile/demo/form-group",
      "name": "表 单"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/form-group",
      "name": "表 单"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/bo-switch",
      "name": "滑动开关"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/bo-number",
      "name": "数字选择"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/calendar",
      "name": "日 历"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/bo-select",
      "name": "下拉菜单"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/selector",
      "name": "选择列表"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/selector-time",
      "name": "时间选择"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/keyboard",
      "name": "数字键盘"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list-title"
  }, [_vm._v("列表&菜单")]), _vm._v(" "), _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "path": "/mobile/demo/listdown",
      "name": "上拉刷新"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/listup",
      "name": "下拉刷新"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "主菜单",
      "dock": "见本页下方"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/tabs",
      "name": "选项卡"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/sidebar",
      "name": "侧栏菜单"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list-title"
  }, [_vm._v("信息提示")]), _vm._v(" "), _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "path": "/mobile/demo/modal",
      "name": "对话框"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/toast",
      "name": "轻提示"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list-title"
  }, [_vm._v("其 他")]), _vm._v(" "), _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "path": "/mobile/demo/animate-number",
      "name": "动画数字"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/carousel",
      "name": "幻灯片"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/stars",
      "name": "评 分"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/login",
      "name": "APP登录"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/car",
      "name": "商品列表"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/seller",
      "name": "电商首页"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/map",
      "name": "地图收货地址"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/demo/imgUploader",
      "name": "上传图片"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/other/product",
      "name": "商 品"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/other/shoppingBar",
      "name": "购物车栏"
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "path": "/mobile/other/content",
      "name": "收缩文本框"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3663c7dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/demos-list.vue
// module id = 239
// module chunks = 36